/**
 * The rhs value of this enum must match one of the source "layers" in the sites
 * resolver (`landinsight-api/lib/sites/persistent/resolver.js`).
 */
export enum SaveSiteLayer {
  Comparables = "pricepaid",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  PricePaid = "pricepaid",
  Constraints = "constraints",
  Planning = "planning",
  Ownership = "ownership",
  PropertyInformation = "propertyInformation",
  Annotations = "annotations",
  Alerts = "alerts",
}
